(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxHowToPrintix(
    $timeout, $filter, toastr, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/setup/howToPrintix/howToPrintix.template.html',
      link: function(scope) {

        (function() {
          
        })();

        scope.$on('$destroy', function() {
        });

        scope.setupAssistant = function () {
          scope.callback()
        }

      }
    };
  }

  pxHowToPrintix.$inject = ['$timeout', '$filter', 'toastr', '$http'];

  angular
    .module('printix-admin')
    .directive('pxHowToPrintix', pxHowToPrintix);

})();
